import React, { createContext, useContext } from 'react';
import proptypes from 'prop-types';

const { node, bool, string } = proptypes;

const PresentationContext = createContext({});
export const usePresentation = () => useContext(PresentationContext);

export const PresentationProvider = ({ 
  useCondensedLayout, 
  itemId = null,
  showProductAttribution = false,
  children 
}) => {
  return (
    <PresentationContext.Provider value={{ useCondensedLayout, itemId, showProductAttribution }}>
      { children }
    </PresentationContext.Provider>
  );
};

PresentationProvider.propTypes = {
  children: node.isRequired,
  useCondensedLayout: bool.isRequired,
  itemId: string,
  showProductAttribution: bool
};
